export default "__VITE_ASSET__BkJcYOSn__"